import { render, staticRenderFns } from "./CopyToClipboardText.vue?vue&type=template&id=bedf641e&scoped=true&"
import script from "./CopyToClipboardText.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardText.vue?vue&type=script&lang=js&"
import style0 from "./CopyToClipboardText.vue?vue&type=style&index=0&id=bedf641e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf641e",
  null
  
)

export default component.exports